import { View, type ViewStyle } from 'react-native';
import BackgroundLiquidEther from '@/components/backgrounds/LiquidEther';
import BackgroundLaserFlow from '@/components/backgrounds/LaserFlow';
import BorderGlowBase from '@/components/effects/BorderGlow';
import ClickSparkBase from '@/components/effects/ClickSpark';
import ElectricBorderBase from '@/components/effects/ElectricBorder';
import AnimatedListBase from '@/components/premium/AnimatedList';
import CarouselBase from '@/components/premium/Carousel';
import FolderBase from '@/components/premium/Folder';
import MagicBentoBase from '@/components/premium/MagicBento';
import ProfileCardBase from '@/components/premium/ProfileCard';
import ScrollStackBase from '@/components/premium/ScrollStack';
import StepperBase from '@/components/premium/Stepper';
import TrueFocusBase from '@/components/premium/TrueFocus';

export function LiquidEther({ children, style }: { children?: React.ReactNode; style?: ViewStyle }) {
  return (
    <View style={[{ position: 'relative', overflow: 'hidden' }, style]}>
      <BackgroundLiquidEther />
      {children}
    </View>
  );
}

export function LaserFlow({ style }: { style?: ViewStyle }) {
  return <View style={[{ position: 'absolute', inset: 0 as any }, style]}><BackgroundLaserFlow /></View>;
}

export function BorderGlow({ children, style }: { children: React.ReactNode; style?: ViewStyle }) {
  return <BorderGlowBase style={style}>{children}</BorderGlowBase>;
}

export function ElectricBorder({ children, style }: { children: React.ReactNode; style?: ViewStyle }) {
  return <ElectricBorderBase style={style}>{children}</ElectricBorderBase>;
}

export function TrueFocus({ text, style }: { text: string; style?: ViewStyle }) {
  return <TrueFocusBase text={text} style={style as any} />;
}

export function ClickSpark({ children, onPress, disabled }: { children: React.ReactNode; onPress: () => void; disabled?: boolean }) {
  return <ClickSparkBase onPress={onPress} disabled={disabled}>{children}</ClickSparkBase>;
}

export const AnimatedList = AnimatedListBase;
export const MagicBento = MagicBentoBase;
export const Carousel = CarouselBase;
export const Stepper = StepperBase;
export const Folder = FolderBase;
export const ProfileCard = ProfileCardBase;
export const ScrollStack = ScrollStackBase;
